import React from "react";
import assets, { menuData, iconData } from "../utils/assets";
import styles from "./commoncard.module.scss";

const Footerhead = () => {
  // const handleClick = () => {
  //   alert("Button Clicked!");
  // };

  return (
    <section className="container ">
      <div className={` ${styles.ontopline} my-4`}></div>

      <div className={styles.footerhead}>
        <div className="row">
          <div className="col">
            <img src={assets.Logo} alt="logo" />
            <p className="col col-lg-4">
              Software + Services that help you grow faster with 100% compliance
            </p>
          </div>
          {/* <div className="col-sm-4 ms-auto">
          <div className={styles.ftmenuitems}>
              <h5> Subscribe to our newsletter</h5>
              <div className={styles.newletterconrol}>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInput"
                  placeholder="Type something..."
                />
              </div>

              <CommonButton
                text="Send a message"
                onClick={handleClick}
                type="secondary"
              ></CommonButton>
            </div>
          </div> */}
        </div>

        <div className={`${styles.ontopline} my-3 my-lg-5`}></div>

        <div className="row">
          {menuData.map((menu, index) => (
            <div key={index} className="col col-12 col-lg-6 mt-2 mt-lg-0">
              <div className={styles.ftmenuitems}>
                <h5>{menu.heading}</h5>
                <ul className="list-unstyled d-flex flex-wrap gap-4">
                  {menu.items.map((item, i) => (
                    <li key={i}>
                      <a href={item.url}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className={`${styles.ontopline} my-3 my-lg-5`}></div>
      </div>
      <div className="container">
        <div className={`row ${styles.footerCopyWrite}`}>
          <div className={`col-md-6 text-center text-md-start`}>
            <p>Copyright © 2025 Toola | All Rights Reserved </p>
          </div>
          <div className={`col-md-6 ${styles.socialAccounts} justify-content-around justify-content-md-end`}>
            {iconData.map((item, index) => (
              <a key={index} href={item.url || "#"} target="_blank" rel="noopener noreferrer">
                <img src={item.icon} alt={item.name} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footerhead;
